import { Download, Loader2 } from 'lucide-react';

/** Botao "Exportar ..." no estilo dos botoes secundarios do design (borda, 38px). */
export function BotaoExportar({ rotulo, exportando, desabilitado, onClick }: { rotulo: string; exportando: boolean; desabilitado?: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={exportando || desabilitado}
      className="flex h-[38px] items-center gap-2 rounded-[10px] border border-border bg-card px-3.5 font-medium hover:bg-line-soft disabled:opacity-60"
    >
      {exportando ? <Loader2 aria-hidden="true" className="size-4 animate-spin" /> : <Download aria-hidden="true" className="size-4" />}
      {rotulo}
    </button>
  );
}

/** Erro da exportacao (mensagem e `code` da API). */
export function ErroExportacao({ erro }: { erro: string | null }) {
  if (!erro) return null;
  return (
    <div role="alert" className="rounded-xl border border-destructive/30 bg-danger-bg px-4 py-3 text-small text-danger-ink">
      Não foi possível exportar: {erro}
    </div>
  );
}
